<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="fallback-icon"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      fill="#9CA3AF"
      stroke="#6B7280"
      :stroke-width="stroke_width || 1"
    />
  </svg>
</template>

<script>
export default {
  name: 'FallbackCircle',
  props: {
    size: {
      type: [String, Number],
      default: 24
    },
    stroke_width: {
      type: [Number, String],
      default: 1
    },
    color: [Boolean, Object, String],
    active: {
      type: Boolean,
      default: true
    },
    is_сolored: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.fallback-icon {
  opacity: 0.6;
}
</style>
